var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "#F1F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2505 15.2498C27.2492 14.0567 26.7747 12.9129 25.9311 12.0692C25.0875 11.2256 23.9436 10.7511 22.7505 10.7498H19.0192C18.7464 10.7339 13.9924 10.3992 9.46518 6.60234C9.24656 6.41873 8.98008 6.30132 8.69705 6.26391C8.41402 6.2265 8.12619 6.27064 7.86738 6.39114C7.60856 6.51163 7.38951 6.70349 7.23595 6.94417C7.08239 7.18484 7.00071 7.46434 7.00049 7.74984V22.7498C7.00053 23.0354 7.08208 23.315 7.23557 23.5558C7.38906 23.7967 7.6081 23.9887 7.86695 24.1093C8.1258 24.2299 8.4137 24.2741 8.69682 24.2367C8.97993 24.1994 9.2465 24.0819 9.46518 23.8983C13.0061 20.9283 16.6839 20.077 18.2505 19.8389V22.8126C18.2502 23.0598 18.3109 23.3032 18.4274 23.5213C18.5439 23.7393 18.7124 23.9252 18.918 24.0623L19.9492 24.7495C20.1486 24.8826 20.3769 24.9659 20.615 24.9926C20.8532 25.0193 21.0943 24.9885 21.3181 24.9028C21.5419 24.8172 21.7419 24.6791 21.9014 24.5003C22.061 24.3214 22.1753 24.107 22.2349 23.8748L23.3383 19.7161C24.4209 19.572 25.4143 19.0398 26.1339 18.2183C26.8535 17.3968 27.2503 16.3419 27.2505 15.2498ZM8.50049 22.7433V7.74984C12.5139 11.1164 16.6221 11.9686 18.2505 12.1786V18.3173C16.6239 18.5311 12.5167 19.3814 8.50049 22.7433ZM20.7817 23.4933V23.5036L19.7505 22.8164V19.7498H21.7755L20.7817 23.4933ZM22.7505 18.2498H19.7505V12.2498H22.7505C23.5461 12.2498 24.3092 12.5659 24.8718 13.1285C25.4344 13.6911 25.7505 14.4542 25.7505 15.2498C25.7505 16.0455 25.4344 16.8085 24.8718 17.3712C24.3092 17.9338 23.5461 18.2498 22.7505 18.2498Z",
    fill: "#052035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.4949d9f112e879a2e5700b620d4dc0f7.svg";
export { ForwardRef as ReactComponent };